import { useDebounceFn } from 'ahooks';
import { type FC, useCallback, useEffect, useState } from 'react';
import { BaseLineUp2 } from '@/app/components/icons/BaseLineUp2';

type ToTopProps = {
  scrollDiv: HTMLElement | null;
  topText?: string;
};

const ToTop: FC<ToTopProps> = ({ scrollDiv, topText }) => {
  const [showTopButton, setShowTopButton] = useState(false);

  const scrollToTop = useCallback(() => {
    if (scrollDiv) scrollDiv.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [scrollDiv]);

  const { run: handleScroll } = useDebounceFn(
    () => {
      if (scrollDiv) setShowTopButton(scrollDiv.scrollTop > 0);
    },
    { wait: 100 },
  );

  useEffect(() => {
    if (!scrollDiv) return;
    scrollDiv.addEventListener('scroll', handleScroll);
    return () => scrollDiv.removeEventListener('scroll', handleScroll);
  }, [scrollDiv, handleScroll]);

  return (
    <div
      className={`group flex cursor-pointer select-none items-center justify-center rounded-full bg-[#404858] p-3 text-2xl transition-all duration-300 hover:bg-[#59667C] ${
        showTopButton ? 'opacity-100' : 'hidden opacity-0'
      }`}
      onClick={scrollToTop}
    >
      <BaseLineUp2 />
      {topText && (
        <div className="ml-0 max-w-0 overflow-hidden whitespace-nowrap text-sm leading-[1] transition-all duration-300 group-hover:ml-1.5 group-hover:max-w-[100px]">
          {topText}
        </div>
      )}
    </div>
  );
};

export default ToTop;
